import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import { CustomMoneyMaskedInput } from "../../../components/custom_input_money_mask";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateItemFolhaPagamentoVerbaColumnDef
 */

type Props = {
  onActionValorUnitarioChange: (idItemFolhaPagamentoVerba: number, valor: number | null) => void;
  onActionQuantidadeChange: (idItemFolhaPagamentoVerba: number, valor: number | null) => void;
  onActionDelete: (idItemFolhaPagamentoVerba: number, openState: boolean) => void;
};

export const GenerateItemFolhaPagamentoVerbaColumnDef = ({
  onActionValorUnitarioChange,
  onActionQuantidadeChange,
  onActionDelete,
}: Props): GridColDef[] => {
  const computeTipoClass = (tipo: number): string => {
    switch (tipo) {
      case 0: return 'bg-[#45b6af] text-white py-[.1rem] px-[.4rem] font-normal';
      case 1: return 'bg-[#f3565d] text-white py-[.1rem] px-[.4rem] font-normal';
      default: return '';
    }
  }

  const computeTipoLabel = (tipo: number): string => {
    switch (tipo) {
      case 0: return 'Acréscimo (+)';
      case 1: return 'Desconto (-)';
      default: return '';
    }
  }

  return [
    {
      field: "nrItemVerba",
      filterable: false,
      headerName: "Nr Verba",
      width: 100,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      width: 135,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            <span className={computeTipoClass(params.value)}>
              {computeTipoLabel(params.value)}
            </span>
          </div>
        );
      },
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Verba",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "valorUnitario",
      filterable: false,
      headerName: "Valor Unitário",
      width: 150,
      minWidth: 150,
      sortable: false,
      editable: false,
      valueGetter: (_, { idItemFolhaPagamentoVerba, valorUnitario, enableEdit }) => ({ idItemFolhaPagamentoVerba, valorUnitario, enableEdit }),
      renderCell: ({ value: { idItemFolhaPagamentoVerba, valorUnitario, enableEdit } }) => (
        <CustomMoneyMaskedInput
          value={valorUnitario}
          readOnly={!enableEdit}
          onChangeValue={value => onActionValorUnitarioChange(idItemFolhaPagamentoVerba, value)} />
      ),

    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade",
      width: 150,
      minWidth: 150,
      sortable: false,
      editable: false,
      valueGetter: (_, { idItemFolhaPagamentoVerba, quantidade, enableEdit }) => ({ idItemFolhaPagamentoVerba, quantidade, enableEdit }),
      renderCell: ({ value: { idItemFolhaPagamentoVerba, quantidade, enableEdit } }) => (
        <CustomMoneyMaskedInput
          value={quantidade}
          readOnly={!enableEdit}
          onChangeValue={value => onActionQuantidadeChange(idItemFolhaPagamentoVerba, value)} />
      ),
    },
    {
      field: "valorVerba",
      filterable: false,
      headerName: "Valor Total",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => (
        (value !== undefined && value !== null) &&
        <div>R$ {value.toFixed(2)}</div>
      ),
    },
    {
      field: "delete",
      filterable: false,
      headerName: "Excluir",
      width: 70,
      minWidth: 70,
      sortable: false,
      valueGetter: (_, { idItemFolhaPagamentoVerba, enableEdit }) => ({ idItemFolhaPagamentoVerba, enableEdit }),
      renderCell: ({ value: { idItemFolhaPagamentoVerba, enableEdit } }) => {
        return (
          <div className="flex items-start justify-center w-full h-full gap-2">
            {
              enableEdit &&
              <IconButton onClick={() => {
                if (enableEdit) {
                  onActionDelete(idItemFolhaPagamentoVerba, true);
                }
              }}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
              </IconButton>
            }
          </div>
        );
      }
    },
  ];
}